/*
 * This file contains the Z-index values for the application.
 * It is used to ensure that the elements are rendered in the correct order.
 */

export const zIndex = {
  global: {
    slidePanel: 'z-[130]',
    layout: 'z-[100]',
    /*
     * O header abre paineis de dropdown que passam da propria barra, entao
     * precisa ficar acima da cromia de pagina: os filtros da rede credenciada
     * (100) e o painel de cluster do mapa (110). Ele empatava com os filtros em
     * 100 e perdia por vir antes no DOM. Continua abaixo do SlidePanel (130) e
     * do ProviderDrawer (150), que cobrem o header de proposito.
     */
    navbar: 'z-[120]',
    /*
     * O menu do hamburger fica entre a camada de vidro da barra (112) e o
     * conteudo do header (120): assim o painel cobre o vidro, e a folga de 8px
     * e o canto arredondado dele aparecem por cima da faixa, sem esconder o X e
     * o logo, que continuam clicaveis. Abaixo do SlidePanel (130) e do
     * ProviderDrawer (150).
     */
    navbarDrawer: 'z-[115]',
    navbarBackdrop: '-z-[1]',
    /*
     * A camada de vidro do header e irma da barra, e nao filha: como a barra
     * cria contexto de empilhamento, de dentro dela nenhum z-index deixaria o
     * painel do menu passar por cima do vidro. Fica acima do painel de cluster
     * (110), que o `backdrop-filter` precisa desfocar, e abaixo do menu (115).
     */
    navbarBlur: 'z-[112]'
  },
  accreditedEstablishments: {
    providerDrawer: 'z-[150]',
    desktopClusterListPanel: '!z-[110]',
    filters: 'z-[100]',
    floatingActionButtons: 'z-[10]'
  }
}
